module.exports = "\n@import \"https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css\";\n/* You can add global styles to this file, and also import other style files */\nbody {\n\n    padding-top: 80px;\n    \n    }\n.template {\n    \n    padding: 3rem 1.5rem;\n    \n    text-align: center;\n    \n    }"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles